<template>
    <div class="performance-overview-container">
        <div class="performance-overview">
            <table>
                <thead>
                    <th>AGENT</th>
                    <th>Referrals</th>
                    <th>Listing <br/>Referrals</th>
                    <th>Won <br/>Listings</th>
                    <th>% Won <br/>Listings</th>
                    <th>First <br/>Attempt</th>
                    <th>CONTACT</th>
                    <th>Successful <br/>Contact</th>
                </thead>
                <slot></slot>
            </table>
        </div>
    </div>
</template>

<script>

export default {
  name: 'PerformanceOverview',
  components: {

  },
  props: {

  },
  data() {
    return {

    };
  },
  created() {

  },
  methods: {

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .performance-overview-container {
        @apply ut--mr-4 ut-ml-0;
        box-shadow: 0 1px 2px 0 rgba(36,33,25,0.09), 0 2px 4px 0 rgba(36,33,25,0.17);

        @screen md {
             @apply ut-mr-0;
        }
    }

    .performance-overview {
        width: 100%;
        overflow-y: auto;

        table {
            width: 900px;
            border-radius: 5px;
            overflow: hidden;


            @screen md {
                @apply ut-w-full;
                width: 100%;
            }

            thead {
                background-color: #ffffff;

                th {
                    @apply ut-text-center ut-py-6 ut-px-2 ut-uppercase;
                    width: 10.5%;
                    background-color: #ffffff;
                    font-size: 10px;
                    font-weight: 700;
                    letter-spacing: 0.8px;
                    line-height: 12px;


                    &:first-child {
                        @apply ut-text-left ut-pl-4;
                        width: 26.5%;
                    }

                    &:last-child {
                        @apply ut-pr-4;
                    }

                }

            }

        }

    }


</style>
